module.exports = __webpack_public_path__ + "img/testimg_qj.a2541254.jpg";